
(function($, document, window) {

	$(function() {
		// jQuery ready!
	});

	const masks = {
		_masks: {
			onlyNumbers: {
				regexp: /[^0-9]/g,
				replacement: ''
			},
			phone: {
				regexp: /^(\d{2})(\d+)(\d{4})$/g,
				replacement: '($1) $2-$3'
			}
		},
		add: function(id, mask) {
			this._masks[id] = mask;
		},
		apply: function(el, masks, maxlength) {			
			el = el[0];

			var self = this;
	
			if(typeof maxlength !== 'undefined' && maxlength != '') {
				el.setAttribute('maxlength', maxlength);
			}
			
			if(masks.length > 0) {
				el.addEventListener('input', function() {
					for(var i = 0; i < masks.length; i++) {
						el.value = el.value.replace(self._masks[masks[i]].regexp, self._masks[masks[i]].replacement);
					}
				});
			}			
		}
	};

	const inputTel = $('[type="tel"]');

	if(inputTel.length > 0) {
		masks.apply(inputTel, ['onlyNumbers', 'phone'], 15);
	}

}(window.jQuery, document, window));